<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [style]="{ width: '620px' }"
  [breakpoints]="{ '680px': '96vw' }"
  styleClass="wl-create-dialog"
  header="Nueva tarea en el Backlog">
  <!-- Confirmación: el folio a la vista y copiable. Es el identificador con el que se
       encarga y se consulta la tarea, y hasta ahora el alta lo generaba sin mostrarlo. -->
  <div class="wl-created" *ngIf="createdCode as code">
    <span class="wc-check"><i class="fa-solid fa-circle-check"></i></span>
    <p class="wc-lead">Tu tarea quedó registrada en el Backlog</p>
    <button type="button" class="wc-code" (click)="copyCode()" [title]="'Copiar ' + code">
      {{ code }}
      <i class="fa-solid" [class.fa-copy]="!copiado" [class.fa-check]="copiado"></i>
    </button>
    <p class="wc-hint" *ngIf="!copiado">Guarda este folio: con él puedes consultar en qué va, o pedirla por su nombre.</p>
    <p class="wc-hint ok" *ngIf="copiado">Copiado al portapapeles.</p>
  </div>

  <form [formGroup]="form" class="wl-form" *ngIf="form && !createdCode">
    <!-- Tipo -->
    <div class="wl-field">
      <label>Tipo</label>
      <div class="wl-type-toggle">
        <button type="button" *ngFor="let t of typeOptions"
          [class.active]="form.get('type')?.value === t.value"
          [style.--accent]="t.color"
          (click)="form.get('type')?.setValue(t.value)">
          <i [class]="t.icon"></i> {{ t.label }}
        </button>
      </div>
    </div>

    <!-- Título -->
    <div class="wl-field">
      <label>Título <span class="req">*</span></label>
      <input type="text" pInputText formControlName="title" placeholder="Ej. Corregir el total del PDF de cotización" />
      <small class="err" *ngIf="form.get('title')?.invalid && form.get('title')?.touched">El título es requerido.</small>
    </div>

    <!-- El alta pide solo lo que sabe quien reporta. El esfuerzo (puntos), el responsable, la
         fecha de entrega y el origen los define el equipo de TI desde el detalle. -->
    <div class="wl-row">
      <div class="wl-field">
        <label>Prioridad</label>
        <p-dropdown [options]="priorityOptions" formControlName="priority" optionLabel="label" optionValue="value"
          placeholder="—" [showClear]="true" styleClass="w-full"></p-dropdown>
      </div>
      <div class="wl-field" *ngIf="isBug">
        <label>Severidad</label>
        <p-dropdown [options]="severityOptions" formControlName="severity" optionLabel="label" optionValue="value"
          placeholder="—" [showClear]="true" styleClass="w-full"></p-dropdown>
      </div>
    </div>

    <!-- Descripción / intake.
         El editor muestra la imagen pegada COMO imagen. La retiene hasta que la tarea exista: en el
         valor queda un token que se cambia por la URL real al crearla. -->
    <div class="wl-field">
      <label>Descripción <span class="wl-paste-hint">· pega una captura con {{ pasteKey }}</span></label>
      <app-worklog-editor formControlName="description" [minRows]="3"
        (imagePasted)="onImagePasted($event)" (imageRemoved)="onImageRemoved($event)"
        placeholder="¿Qué se necesita y por qué? Información que dejas para quien lo tome. Puedes pegar capturas."></app-worklog-editor>
    </div>

    <div class="wl-field">
      <label>Criterios de aceptación</label>
      <app-worklog-editor formControlName="acceptanceCriteria" [minRows]="2"
        (imagePasted)="onImagePasted($event)" (imageRemoved)="onImageRemoved($event)"
        placeholder="¿Cuándo se considera terminada?"></app-worklog-editor>
    </div>

    <div class="wl-field" *ngIf="isBug">
      <label>Pasos para reproducir <span class="wl-paste-hint">· pega una captura con {{ pasteKey }}</span></label>
      <app-worklog-editor formControlName="stepsToReproduce" [minRows]="2"
        (imagePasted)="onImagePasted($event)" (imageRemoved)="onImageRemoved($event)"
        placeholder="1. … 2. … 3. …"></app-worklog-editor>
    </div>

    <div class="wl-field" *ngIf="isBug">
      <label>Resultado esperado</label>
      <app-worklog-editor formControlName="expectedResult" [minRows]="2"
        (imagePasted)="onImagePasted($event)" (imageRemoved)="onImageRemoved($event)"></app-worklog-editor>
    </div>

    <!-- Las imágenes ya se ven dentro del texto, así que aquí solo va el aviso de que todavía no
         están en el servidor: se suben al guardar, cuando la tarea ya tiene id al que colgarlas. -->
    <div class="wl-pending" *ngIf="pendingImages.length">
      <span class="wl-pending-t"><i class="pi pi-paperclip"></i> {{ pendingImages.length }} imagen(es) se subirán al crear la tarea</span>
    </div>

    <!-- Archivos: el Excel, el PDF, el contrato. Van en su propio campo y no pegados en el texto,
         porque son material de trabajo y no ilustración: en el detalle viven en la sección
         Archivos, separados de las capturas. Se retienen hasta crear la tarea, igual que las
         imágenes. -->
    <div class="wl-field">
      <label>Archivos <span class="wl-paste-hint">· opcional</span></label>
      <label class="wl-drop" (drop)="onFilesDropped($event)" (dragover)="$event.preventDefault()">
        <input type="file" multiple hidden (change)="addFiles($any($event.target).files); $any($event.target).value = ''" />
        <i class="fa-solid fa-paperclip" aria-hidden="true"></i>
        Suelta los archivos aquí o <u>búscalos en la computadora</u>
      </label>
      <ul class="wl-files" *ngIf="pendingFiles.length">
        <li class="wl-file" *ngFor="let f of pendingFiles; let i = index">
          <i [class]="fileIcon(f)" aria-hidden="true"></i>
          <span class="wl-file-name" [title]="f.name">{{ f.name }}</span>
          <span class="wl-file-meta">{{ fileSize(f.size) }}</span>
          <button type="button" class="wl-file-x" (click)="removeFile(i)" [attr.aria-label]="'Quitar ' + f.name" title="Quitar">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </li>
      </ul>
    </div>

    <!-- Aquí vivía "¿Necesitas una fecha fija?". Se retiró: quien reporta no fija fechas de
         entrega. En la práctica todo el mundo se ponía una, así que dejaron de significar nada y
         llenaban de compromisos falsos las vistas de tiempos. La fecha de entrega la pone el
         equipo desde el detalle de la tarea; del alta solo queda su fecha de registro. -->
  </form>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="createdCode; else pieFormulario">
      <button type="button" class="wl-btn ghost" (click)="otra()"><i class="fa-solid fa-plus"></i> Registrar otra</button>
      <button type="button" class="wl-btn primary" (click)="close()">Listo</button>
    </ng-container>

    <ng-template #pieFormulario>
    <span class="wl-foot-hint">
      <i class="fa-solid fa-circle-info"></i>
      El equipo de desarrollo define las áreas técnicas, el esfuerzo, el responsable y la fecha de entrega.
    </span>
    <button type="button" class="wl-btn ghost" (click)="close()">Cancelar</button>
    <button type="button" class="wl-btn primary" [disabled]="saving" (click)="submit()">
      <i class="fa-solid" [class.fa-plus]="!saving" [class.fa-spinner]="saving" [class.fa-spin]="saving"></i>
      Crear tarea
    </button>
    </ng-template>
  </ng-template>
</p-dialog>
